/** Search and sort for the MCP Servers catalog (#939, Feature E). Pure, so it's unit-testable. */

import type { McpServer } from "./mcp-registry";
import type { McpSort } from "./routing";

/** Case-insensitive match on title, server name or description. */
export function mcpServerMatches(server: McpServer, query: string): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  return [server.title, server.serverName, server.description].some((field) => field.toLowerCase().includes(q));
}

/** Filters by the search and sorts: Name (A–Z by title) or Recently added (newest first, then title). */
export function filterAndSortMcpServers(servers: readonly McpServer[], query: string, sort: McpSort): McpServer[] {
  const list = servers.filter((s) => mcpServerMatches(s, query));
  if (sort === "recent") {
    return list.sort((a, b) => b.publishedAt.localeCompare(a.publishedAt) || a.title.localeCompare(b.title));
  }
  return list.sort((a, b) => a.title.localeCompare(b.title));
}
